import types from "./types";

export default {
  app_data: (payload) => ({ type: types.APP_DATA, payload }),
  // app_data_loading: payload => ({type: types.APP_DATA_LOADING, payload}),
  app_data_finished: (payload) => ({ type: types.APP_DATA_FINISHED, payload }),
  app_data_failed: (payload) => ({ type: types.APP_DATA_FAILED, payload }),
  logout: () => ({ type: types.LOGOUT }),
};
